import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { imageData } from "../../Data/Demodata/Demo";

const DemoHome = () => {
  return (
    <section className='theme-bg home'>
      <div className='animation-circle-inverse'>
        <i></i> <i></i> <i></i>
      </div>
      <div className='animation-circle-inverse absolute'>
        <i></i> <i></i> <i></i>
      </div>
      <Container>
        <Row>
          <Col md={6}>
            <div className='home-contain'>
              <div className='fadeInLeft-land-caption'>
                <h2 className='landing-caption text-white'>Best App Landing for all your needs.. !</h2>
                <p className='text-white'>Chatloop is perfect landing page for game , photoediting , browser or any mobile application landing page</p>
                <div>
                  <Link to={`${process.env.PUBLIC_URL}/home`} className='btn btn-inverse mt-2 mr-3'>
                    Check Now
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col md={6} className='right'>
            <div className='home-right'>
              {imageData.map((image, index) => (
                <div className={image.className} key={index}>
                  <img src={image.src} alt={image.alt} className='img-fluid' />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DemoHome;
